import { Suspense } from 'react';
import { FederatedErrorBoundary } from '@components/RemoteMicroFrontends/FederatedErrorBoundary';
import { FooterFallback } from '@components/RemoteMicroFrontends/fallbacks';
import { Outlet } from 'react-router-dom';
import { ErrorInfo, lazy } from 'react';
import { useSidebarInit } from '@hooks/useSidebarInit';
import { useApplyingCollegesSync } from '@hooks/useApplyingCollegesSync';
import { usePreferencesSync } from '@hooks/usePreferencesSync';
import { Header } from './components';
import { StyledLayoutWrap, StyledMain, StyledFooter } from './Layout.styles';
// lazy components
const Footer = lazy(() => import('brightpathHeader/Footer'));

export const Layout = () => {
  usePreferencesSync();
  useApplyingCollegesSync();
  const { isMobileScreen, isMobileSidebarRoute, mobileSidebar, desktopSidebar } = useSidebarInit();

  return (
    <>
      <Header />

      <StyledLayoutWrap isRowDirection={!isMobileSidebarRoute}>
        <Suspense fallback={null}>{isMobileScreen ? mobileSidebar : desktopSidebar}</Suspense>

        <StyledMain isNeedToAddPaddingTop={isMobileSidebarRoute}>
          <Outlet />
        </StyledMain>
      </StyledLayoutWrap>

      <Suspense fallback={null}>
        {isMobileScreen ? (
          <Suspense fallback={null}>
            <FederatedErrorBoundary
              moduleName="brightpathFooter"
              fallback={<FooterFallback />}
              onError={(error: Error, errorInfo: ErrorInfo) => {
                console.error('Failed to load Footer:', error);
              }}
            >
              <Footer />
            </FederatedErrorBoundary>
          </Suspense>
        ) : (
          <StyledFooter />
        )}
      </Suspense>
    </>
  );
};
